export default __webpack_public_path__ + "static/image-cv-web@2x-e8c821209a6c7d79aa0b39c5d92e8371.png";